import * as $ from 'jquery';
// import Debouncer from '../../lib/Debouncer';
// import { Analytics } from '@plaudit/analytics';

// NOTE: detailsSummary because it's already used
export default class Details {
	private $item: JQuery = $('.detailsSummary');
	private className: string = 'detailsSummary__heading';
	private selector_trigger: string = '.detailsSummary__heading';
	private selector_target: string = '.detailsSummary__content';

	toggleItem(element: Element, force?: boolean): void {
		const $element = $(element);
		const isOpen = $element.parent().hasClass('target');

		if (isOpen){
			$element.parent().removeClass('target');
			$element.next().stop(true).slideUp();
		} else {
			$element.parent().addClass('target');
			$element.next().stop(true).slideDown();
		}
	}
	toggleItemTargeted(): void {
		let id = (window.location.hash).replace(/([\.\:])/, '\\$1');
		const $targetedElement = this.$item.find(id);

		if ($targetedElement.hasClass(this.className)) {
			this.toggleItem($targetedElement.get(0));
		}
	}
	// toggleItemFirst():void {
	// 	let hash = (window.location.hash);
	// 	if (!hash) {
	// 		this.toggleItem(this.$item.find(this.selector_trigger).get(0));
	// 	}
	// }
	toggleItemAll():void {
		if (!window.location.hash) {
			let triggers = this.$item.find(this.selector_trigger);
			this.$item.find(this.selector_trigger).each((id) => {
				this.toggleItem(triggers.get(id));
			});
		}
	}
	setupIcons(): void {
		let svg = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26 26" width="26" height="26">
	<path class="svg-path-v" d="M12 5h2v16h-2z"/>
	<path class="svg-path-h" d="M5 12h16v2H5z"/>
	<path d="M13 26C5.8 26 0 20.2 0 13S5.8 0 13 0s13 5.8 13 13-5.8 13-13 13zm0-24C6.9 2 2 6.9 2 13s4.9 11 11 11 11-4.9 11-11S19.1 2 13 2z"/>
</svg>`;

		$(this.selector_trigger).append(svg);
	}
	setupEventHandlers(): void {
		this.$item.on('click', this.selector_trigger, (event: JQueryMouseEventObject) => {
			event.preventDefault();
			history.replaceState(undefined, undefined, location.pathname + "#" + event.currentTarget.id);
			this.toggleItem(event.currentTarget);
		});
	}

	constructor() {
		if (!this.$item) {
			return;
		}
		this.setupIcons();
		this.setupEventHandlers();
		this.$item.addClass('js-ready');

		let goo = () => {
			this.$item.find(this.selector_trigger).siblings(this.selector_target).slideUp(0);
		};
		$.when(goo()).done(() => {
			this.toggleItemTargeted();
			// this.toggleItemFirst();
			this.toggleItemAll();
		});
	}
}
